module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step2_Image22.302319a6.jpg";